import { Component, Output } from '@angular/core';

import { HintsComponent } from '../hints/hints.component';
import { LogsComponent } from '../logs/logs.component';
import { CommentsComponent } from '../comments/comments.component';

@Component({
  moduleId: module.id,
  selector: 'page-container',
  templateUrl: 'page.component.html',
  styleUrls: ['page.component.scss'],
})
export class PageComponent {
  rightPanelNavs: any[] = [
    {
      title: 'Hints',
      name: 'hints',
      active: true,
      component: HintsComponent,
    },
    {
      title: 'Logs',
      name: 'logs',
      active: false,
      component: LogsComponent,
    },
    {
      title: 'Comments',
      name: 'comments',
      active: false,
      component: CommentsComponent,
    }
  ];

  showActionPanel() {
    return true;
  }
}
